module.exports = __webpack_public_path__ + "static/media/tutorial.b0af70ed.png";